"use client";

import { forwardRef } from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import type { Visibility } from "./schema";

export const VISIBILITY_OPTIONS: { value: Visibility; label: string }[] = [
  {
    value: "public",
    label: "Shared (visible to everyone in your organization)",
  },
  { value: "private", label: "Private (only visible to you)" },
];

interface VisibilityInputProps {
  value: Visibility;
  onChange: (v: Visibility) => void;
  className?: string;
  id?: string;
  name?: string;
  onBlur?: () => void;
  "aria-labelledby"?: string;
  "aria-describedby"?: string;
  "aria-invalid"?: boolean;
}

export const VisibilityInput = forwardRef<HTMLDivElement, VisibilityInputProps>(
  function VisibilityInput(
    { value, onChange, className, onBlur, ...rest },
    ref,
  ) {
    return (
      <div
        ref={ref}
        role="radiogroup"
        className={cn("flex flex-col gap-3", className)}
        {...rest}
      >
        {VISIBILITY_OPTIONS.map((opt) => {
          const checked = value === opt.value;
          return (
            <label
              key={opt.value}
              className="flex cursor-pointer items-center gap-2.5 text-sm font-medium text-foreground"
            >
              <Checkbox
                checked={checked}
                onChange={() => {
                  onChange(opt.value);
                  onBlur?.();
                }}
              />
              <span className="leading-5">{opt.label}</span>
            </label>
          );
        })}
      </div>
    );
  },
);
